import { render, staticRenderFns } from "./availability.vue?vue&type=template&id=1d8b96ca"
import script from "./availability.vue?vue&type=script&lang=js"
export * from "./availability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports